import { Routes } from '@angular/router';
import { LayoutComponent } from '@layout/layout.component';
import { DashboardResidentPageComponent } from '@dashboard/pages/dashboard-resident-page/dashboard-resident-page.component';
import { authenticationGuard } from '@guards/authentication.guard';
import { communityGuard } from '@guards/customer/community.guard';
import { corporationGuard } from '@guards/corporation.guard';
import { NotFoundPageComponent } from './shared/pages/not-found-page/not-found-page.component';
import { DashboardFamilyPageComponent } from '@dashboard/pages/dashboard-family-page/dashboard-family-page.component';
import { moduleGuard } from '@guards/module.guard';

export const routes: Routes = [
  {
    path: '404',
    component: NotFoundPageComponent,
  },

  {
    path: '',
    component: LayoutComponent,
    canActivate: [authenticationGuard, moduleGuard],
    children: [
      {
        path: '',
        component: DashboardResidentPageComponent,
      },
      {
        path: 'messages',
        loadChildren: () =>
          import('./features/messages/messages.routes').then((r) => r.residentRoutes),
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./features/calendar/calendar.routes').then((r) => r.residentRoutes),
      },
      {
        path: 'tsolife-games',
        loadChildren: () => import('./features/tsolife-games/tsolife-games.routes'),
      },
      {
        path: 'directory',
        loadChildren: () => import('./features/directory/directory.routes'),
      },
      {
        path: 'announcements',
        loadChildren: () =>
          import('./features/announcements/announcements.routes').then((r) => r.residentRoutes),
      },

      {
        path: 'dining',
        loadChildren: () => import('./features/dining/dining.routes'),
      },
      {
        path: 'gallery',
        loadChildren: () => import('./features/gallery/gallery.routes'),
      },
      {
        path: 'surveys',
        loadChildren: () =>
          import('./features/surveys/surveys.routes').then((r) => r.residentRoutes),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./features/notifications/notifications.routes').then((r) => r.residentRoutes),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((r) => r.residentRoutes),
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./features/documents/documents.routes').then((r) => r.residentRoutes),
      },

      {
        path: 'service-requests',
        loadChildren: () => import('./features/service-requests/service-requests.routes'),
      },
    ],
  },

  {
    path: 'family',
    component: LayoutComponent,
    canActivate: [authenticationGuard, moduleGuard],
    children: [
      {
        path: '',
        component: DashboardFamilyPageComponent,
      },
      {
        path: 'messages',
        loadChildren: () =>
          import('./features/messages/messages.routes').then((r) => r.familyRoutes),
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./features/calendar/calendar.routes').then((r) => r.familyRoutes),
      },
      {
        path: 'announcements',
        loadChildren: () =>
          import('./features/announcements/announcements.routes').then((r) => r.familyRoutes),
      },

      {
        path: 'dining',
        loadChildren: () => import('./features/dining/dining.routes'),
      },

      {
        path: 'feed-back',
        loadChildren: () => import('./features/surveys/surveys.routes').then((r) => r.familyRoutes),
      },
      {
        path: 'gallery',
        loadChildren: () => import('./features/gallery/gallery.routes'),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./features/notifications/notifications.routes').then((r) => r.familyRoutes),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((r) => r.familyRoutes),
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./features/documents/documents.routes').then((r) => r.familyRoutes),
      },
    ],
  },

  {
    path: 'corporation/:corporationId',
    canActivate: [corporationGuard],
    children: [
      {
        path: '',
        redirectTo: 'authentication',
        pathMatch: 'full',
      },
      {
        path: 'authentication',
        loadChildren: () => {
          console.log('🛣️ Application Routes - Loading authentication routes for corporation');
          return import('./features/authentication/authentication.routes');
        },
      },
    ],
  },

  {
    path: ':community',
    canActivate: [communityGuard],
    children: [
      {
        path: '',
        redirectTo: 'authentication',
        pathMatch: 'full',
      },
      {
        path: 'authentication',
        loadChildren: () => import('./features/authentication/authentication.routes'),
      },
    ],
  },

  {
    path: '**',
    redirectTo: '404',
  },
];
